import i18next from "i18next";
import { ERROR, ERROR_DESCRIPTION_GENERIC } from "../locales/keysTranslations";
import { SimpleAlert } from "../utils/alerts";
import { ALERT_ICON_TYPE_ERROR } from "../utils/constants";
import { getObjectError } from "../utils/formats";

export const onInit3DSecureAuth = async ({
  clientSecret,
  stripe,
  onCallbackFailed = () => {},
}) => {
  const { error, paymentIntent } = await stripe.confirmCardPayment(
    clientSecret
  );
  if (error) {
    const errorFormatted = getObjectError(error);
    SimpleAlert({
      title: i18next.t(ERROR),
      text: i18next.t(ERROR_DESCRIPTION_GENERIC, {
        message: errorFormatted.message,
        code: errorFormatted.code,
      }),
      icon: ALERT_ICON_TYPE_ERROR,
    });
    onCallbackFailed();
    return { ok: false };
  }
  if (paymentIntent.status === "succeeded") {
    return { ok: true, paymentIntent: paymentIntent.id };
  }
};
